import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable, of } from 'rxjs';
import { ErrorLogComponent } from '../../components/error-log/error-log.component';
import { EmailLogInterface } from './email-log.interface';

@Injectable({
    providedIn: 'root',
})
export class EmailLogService implements EmailLogInterface {
    public constructor(private readonly modalService: BsModalService) {}

    public sendEmailLog(emailBody: string): Observable<void> {
        console.log('we should send the following email body:', emailBody);
        this.modalService.show(ErrorLogComponent, {
            backdrop: 'static',
            class: 'modal-lg',
            ariaLabelledBy: 'error-log-modal-title',
        });
        return of(undefined);
    }
}
